import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Layout } from "../components/tag/Layout";
import { useAuth, formatApiError } from "../contexts/AuthContext";

export default function PortalRegister() {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const { register } = useAuth();
  const [email, setEmail] = useState(params.get("email") || "");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) {
      toast.error("Password must be at least 8 characters.");
      return;
    }
    setBusy(true);
    try {
      await register(email, password, name);
      toast.success("Account created. Welcome.");
      nav("/portal", { replace: true });
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Layout title="Create Portal Account | The Authority Gap" path="/portal/register">
      <section style={{ background: "#090909", padding: "80px 20px" }}>
        <div className="tag-card" data-testid="portal-register-card" style={{ maxWidth: 420, margin: "0 auto", padding: 32 }}>
          <h2 className="tag-h2" style={{ marginBottom: 6 }}>Create your portal account</h2>
          <p style={{ color: "#888", fontSize: 12, marginBottom: 24, lineHeight: 1.6 }}>
            Use the same email you purchased with. The portal is reserved for paying customers (Audit $49+, Blueprint, Launch Kit, Build).
          </p>
          <form onSubmit={submit}>
            <label style={{ color: "#888", fontSize: 11, fontWeight: 600 }}>Full name</label>
            <input data-testid="portal-register-name" required value={name} onChange={(e) => setName(e.target.value)} className="tag-input" style={{ marginBottom: 14 }} />
            <label style={{ color: "#888", fontSize: 11, fontWeight: 600 }}>Email</label>
            <input data-testid="portal-register-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="tag-input" style={{ marginBottom: 14 }} />
            <label style={{ color: "#888", fontSize: 11, fontWeight: 600 }}>Password (min 8 chars)</label>
            <input data-testid="portal-register-password" type="password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} className="tag-input" style={{ marginBottom: 20 }} />
            <button data-testid="portal-register-submit" type="submit" className="btn-primary" style={{ width: "100%" }} disabled={busy}>
              {busy ? "Creating…" : "Create account"}
            </button>
          </form>
          <div style={{ marginTop: 18, textAlign: "center", fontSize: 12 }}>
            Already have an account? <Link to="/portal/login" style={{ color: "#FF6575" }}>Sign in</Link>
          </div>
        </div>
      </section>
    </Layout>
  );
}
